// Base types

export type IdType = string; // 24-character string
export type EmailType = string; // validated string
export type PasswordType = string; // validated string

export const isValidId = (id: unknown): id is IdType =>
  typeof id === "string" && id.length === 24;

export const isValidPassword = (pwd: unknown): pwd is PasswordType =>
  typeof pwd === "string" && pwd.length >= 6 && pwd.length <= 64;

export const isValidEmail = (email: unknown): email is EmailType =>
  typeof email === "string" &&
  email.length <= 254 &&
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const isValidPrice = (price: unknown) =>
  (typeof price === "string" || typeof price === "number") &&
  String(price).length <= 254 &&
  /^[0-9]{1,5}([,.]\d{1,2})?$/.test(String(price));

export const isValidOTP16 = (otp: unknown): otp is string =>
  typeof otp === "string" && otp.length === 16;

export const isValidOTP6 = (otp: unknown): otp is string =>
  typeof otp === "string" && otp.length === 6;
